import { ChangeEvent } from 'react'

import { Input } from '@ui/components/Input/Input'
import { CloseIcon } from '@ui/icons/Close.icon'
import { SearchIcon } from '@ui/icons/Search.icon'

export interface InputSearchProps {
  className?: string
  value?: string
  label?: string
  isFullWidth?: boolean
  isAutoFocus?: boolean
  delay?: number
  onChange?: (event: ChangeEvent<HTMLInputElement>) => void
  onClear?: () => void
  onClick?: () => void
  ref?: React.Ref<HTMLInputElement>
}

export const InputSearch: React.FC<InputSearchProps> = (props) => {
  const { value, label, isAutoFocus, onChange, onClear, onClick, ref } = props

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    onChange?.(event)
  }

  const handleClear = () => {
    onClear?.()
  }

  const handleClick = () => {
    onClick?.()
  }

  return (
    <Input
      type='text'
      label={label}
      value={value}
      onChange={handleChange}
      autoFocus={isAutoFocus}
      onClick={handleClick}
      variant='search'
      size='lg'
      leftIcon={SearchIcon}
      rightIcon={value?.length ? CloseIcon : undefined}
      onEndIconClick={handleClear}
      ref={ref}
    />
  )
}
